import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Main button preview component.
 * Renders the main Shortways button with optional red notification point.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters for button display
 * @returns {JSX.Element}
 */
export default function PreviewMainButton({ parameters }) {
  const { t } = useLanguage()

  return (
    <div>
      <div className="preview_headerBloc">{t("MainButton.mainButtonTitle")}</div>
      <div id="preview_mainButton" className="mx-auto">
        {parameters?.displayRedpoint && <div className="redpoint">11</div>}
        <button id="shortwaysButtonMain" className="btn" type="button" data-testid="shortwaysButtonMain"></button>
      </div>
    </div>
  )
}
